module.exports = __webpack_public_path__ + "static/media/city_view_grey.bfb02b63.svg";